var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        filterable: "",
        remote: "",
        clearable: "",
        "remote-method": _vm.querySearch,
        placeholder: "姓名或淘金号或登录账号"
      },
      on: { clear: _vm.onClear, change: _vm.onChange },
      model: {
        value: _vm.tjkName,
        callback: function($$v) {
          _vm.tjkName = $$v
        },
        expression: "tjkName"
      }
    },
    _vm._l(_vm.userList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.label, value: item.id }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a28db14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a28db14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tjkAutoCompleteAll.vue
// module id = 2007
// module chunks = 0